import { coerceCssPixelValue } from '@angular/cdk/coercion';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'cssPixelValue',
})
export class CssPixelValuePipe implements PipeTransform {
  transform(value: any): unknown {
    return coerceCssPixelValue(value);
  }
}
